export default __webpack_public_path__ + "static/TSD_Home_Page_Collage_Our_Goal-fc4304ee06a7dbf6c299f17b8af66dcc.png";